import { ReactNode, useEffect, useRef } from "react";
import { Player } from "../..";

const DEFAULT_PANIC_URL = "https://www.google.com/search?igu=1";

export function PanicFrame({ children }: { children: ReactNode }) {
  const { data } = Player.usePanic();
  const isPanic = checkPanic(data);
  const prevIsPanicRef = useRef(isPanic);

  useEffect(() => {
    if (isPanic) {
      window.document.title = "Welcome";
    }

    if (!isPanic && prevIsPanicRef.current) {
      window.location.reload();
    }

    prevIsPanicRef.current = isPanic;
  }, [isPanic]);

  if (!isPanic) {
    return <>{children}</>;
  }

  return (
    <iframe
      src={data.redirectUrl || DEFAULT_PANIC_URL}
      style={{
        background: "white",
        border: 0,
        position: "fixed",
        inset: 0,
        height: "100%",
        width: "100%",
        zIndex: 99999999,
      }}
    />
  );
}

function checkPanic(data: unknown): data is { redirectUrl?: string } {
  return typeof data === "object" && data !== null && "redirectUrl" in data;
}
